import { StandardTextFieldProps } from "@mui/material"
import { LocalizationProvider, TimePicker, TimeView } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import moment from "moment"
import { TimeUtils } from "../../utils/TimeUtils"
import { TimeConvention, useLocalStorageStore } from "../../zstore/LocalStorageStore"

interface TimeFieldProps extends Omit<StandardTextFieldProps, "onChange"> {
    field: string
    onChange: (field: string, value: string, moment: moment.Moment | null) => void
    value: string
    error?: boolean
    includeSeconds?: boolean
}

const defaultTimeView: TimeView[] = ["hours", "minutes"]

export const TimeField = ({
    field,
    required,
    value,
    onChange,
    error = false,
    includeSeconds,
    ...props
}: TimeFieldProps) => {
    const timeFormat = useLocalStorageStore((state) => state.timeConvention)
    const isTimeConvention12Hours = timeFormat === TimeConvention.TWELVE
    const formatString = TimeUtils.getTimeFormatString({ format: timeFormat, includeSeconds })

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <TimePicker
                format={formatString}
                value={value != null ? moment(value, formatString) : null}
                onChange={(time) => {
                    // formats the value to twenty-four hour ver for consistent saving to db
                    const timeAsTwentyFour = time?.format(TimeUtils.getTimeFormatString({ includeSeconds })) || ""
                    onChange(field, timeAsTwentyFour, time)
                }}
                views={includeSeconds ? [...defaultTimeView, "seconds"] : defaultTimeView}
                ampm={isTimeConvention12Hours}
                slotProps={{
                    textField: {
                        size: "small",
                        helperText: required && "Required",
                        error: (required && value == null) ?? error,
                        ...props,
                    },
                }}
            />
        </LocalizationProvider>
    )
}
